import React, { useRef } from 'react';
import { Carousel } from 'antd';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { CarouselRef } from 'antd/es/carousel';

interface VideoData {
  id: string;
  embedId: string;
  title: string;
}

const You3: React.FC = () => {
  const carouselRef = useRef<CarouselRef>(null);

  // Sample YouTube Shorts data - replace with your actual video IDs
  const videos: VideoData[] = [
    {
      id: '1',
      embedId: 'Mq3ENiVMOXw',
      title: 'Registering a Vehicle'
    },
    {
      id: '2',
      embedId: 'rkwJsfbXZbE',
      title: 'Contact Car Owner'
    },
    {
      id: '3',
      embedId: '38J0LyFbwGA',
      title: 'Apply SpotGenie To Bike'
    },
    {
      id: '4',
      embedId: 'hoA0_XTZZIM',
      title: 'Apply SpotGenie To Car'
    },
    // {
    //   id: '5',
    //   embedId: 'ScMzIvxBSi4',
    //   title: 'Fitness Workout'
    // },
    // {
    //   id: '6',
    //   embedId: '9bZkp7q19f0',
    //   title: 'Art Tutorial'
    // }
  ];

  const handlePrev = () => {
    carouselRef.current?.prev();
  };

  const handleNext = () => {
    carouselRef.current?.next();
  };

  return (
    <div className="relative max-w-7xl mx-auto rounded-2xl bg-[#EDF1F7] overflow-hidden p-4">
      {/* Left Arrow */}
      <button
        onClick={handlePrev}
        className="absolute left-2 top-1/2 transform -translate-y-1/2 z-10 bg-white bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-2 transition-all duration-200 hover:scale-110"
        aria-label="Previous video"
        id="left_yt_vid_btn"
      >
        <ChevronLeft color='black' size={32} />
      </button>

      {/* Right Arrow */}
      <button
        onClick={handleNext}
        id="right_yt_vid_btn"
        className="absolute right-2 top-1/2 transform -translate-y-1/2 z-10 bg-white bg-opacity-50 hover:bg-opacity-70 text-white rounded-full p-2 transition-all duration-200 hover:scale-110"
        aria-label="Next video"
      >
        <ChevronRight color='black' size={32} />
      </button>

      {/* Carousel */}
      <Carousel
        ref={carouselRef}
        dots={false}
        infinite={true}
        speed={500}
        slidesToShow={3}
        slidesToScroll={1}
        className="youtube-shorts-carousel"
        responsive={[
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]}
      >
        {videos.map((video) => (
          <div key={video.id} className="px-2">
            <div className="relative">
              <div className="aspect-[9/16] !rounded-xl overflow-hidden">
                <iframe
                  src={`https://www.youtube.com/embed/${video.embedId}?controls=1&modestbranding=1&rel=0&showinfo=0`}
                  title={video.title}
                  className="w-full h-full !rounded-xl"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              
              {/* Optional overlay with video title */}
              {/* <div className="absolute bottom-0 bg-gradient-to-t from-black to-transparent p-3 w-full">
                <h3 className="text-white text-sm font-medium truncate">
                  {video.title}
                </h3>
              </div> */}
            </div>
          </div>
        ))}
      </Carousel>

      {/* Custom dots indicator */}
      <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {videos.map((_, index) => (
          <div
            key={index}
            className="w-2 h-2 rounded-full bg-white bg-opacity-50"
          />
        ))}
      </div>


    </div>
  );
};

export default You3;